(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1940,7664,1937,8931],{

/***/ 7664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAutor = function SvgAutor(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 13"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M9.429 11.725H.57a.385.385 0 0 0-.384.384c0 .217.167.384.384.384h8.86a.385.385 0 0 0 .384-.384.385.385 0 0 0-.384-.384ZM.93 10.97l5.772-2.138a.365.365 0 0 0 .23-.243l.756-2.663.064.052a.386.386 0 0 0 .538-.064l1.433-1.792a.37.37 0 0 0-.064-.525L5.666.397A.37.37 0 0 0 5.14.46L3.707 2.253a.37.37 0 0 0 .064.525l.064.05-2.419 1.345a.437.437 0 0 0-.192.281L.418 10.56c-.026.269.269.5.512.41Zm4.556-9.741 3.405 2.713-.947 1.204-3.405-2.714.947-1.203ZM1.954 4.736l2.483-1.42L7.112 5.44 6.28 8.18l-4.34 1.6 1.575-1.972a1.43 1.43 0 0 0 1.703-.422 1.448 1.448 0 0 0-.23-2.036 1.446 1.446 0 0 0-2.036.23 1.441 1.441 0 0 0-.026 1.767L1.352 9.318l.602-4.582ZM3.54 6.054a.706.706 0 0 1 .973-.115.706.706 0 0 1 .115.973.706.706 0 0 1-.973.115.694.694 0 0 1-.115-.973Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgAutor);

/***/ }),

/***/ 71937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M11 1.333h-1v-1a.333.333 0 0 0-.667 0v1H2.667v-1a.333.333 0 0 0-.667 0v1H1a1 1 0 0 0-1 1V11a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2.333a1 1 0 0 0-1-1ZM1 2h1v1a.333.333 0 1 0 .667 0V2h6.666v1A.333.333 0 1 0 10 3V2h1a.333.333 0 0 1 .333.333v2.334H.667V2.333A.333.333 0 0 1 1 2Zm10 9.333H1A.333.333 0 0 1 .667 11V5.333h10.666V11a.333.333 0 0 1-.333.333Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgCalendar);

/***/ }),

/***/ 68931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTiempo = function SvgTiempo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 14"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M8.553 1.83v2.5c0 1.168-.832 2.206-2.01 2.703 1.188.47 2.01 1.468 2.01 2.619v2.491a.915.915 0 0 1-.02 1.83H1.465a.915.915 0 0 1-.02-1.83V9.652c0-1.151.822-2.148 2.011-2.62-1.178-.496-2.01-1.534-2.01-2.702v-2.5A.915.915 0 0 1 1.465 0h7.067a.915.915 0 0 1 .02 1.83ZM1.205 13.057c0 .144.117.26.26.26h7.069a.26.26 0 1 0 0-.52H1.465a.26.26 0 0 0-.26.26ZM2.1 9.652v2.49h5.798v-2.49a2.015 2.015 0 0 0-.825-1.567A3.321 3.321 0 0 0 4.999 7.4a3.32 3.32 0 0 0-2.074.687A2.015 2.015 0 0 0 2.1 9.652Zm.831-3.697a3.28 3.28 0 0 0 4.135 0c.503-.394.807-.988.832-1.625v-2.5H2.1v2.5c.026.637.33 1.231.832 1.625Zm5.602-5.3H1.465a.26.26 0 1 0 0 .52h7.068a.26.26 0 1 0 0-.52Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgTiempo);

/***/ }),

/***/ 97516:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[uri]",
      function () {
        return __webpack_require__(7776);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ flexible_content; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/templates/flexible-content/FlexibleContent.tsx






var Benefits = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(7028)]).then(__webpack_require__.bind(__webpack_require__, 97028));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97028)
            ];
        }
    }
});
var BuildingCarrousel = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(5044), __webpack_require__.e(3405)]).then(__webpack_require__.bind(__webpack_require__, 24324));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24324)
            ];
        }
    }
});
var Faqs = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 701).then(__webpack_require__.bind(__webpack_require__, 70701));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(70701)
            ];
        }
    }
});
var PopUpCorner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8234).then(__webpack_require__.bind(__webpack_require__, 88234));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88234)
            ];
        }
    }
});
var PopUpOpenPage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 29535));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29535)
            ];
        }
    }
});
var WhatsappPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7591).then(__webpack_require__.bind(__webpack_require__, 87591));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87591)
            ];
        }
    }
});
var Hero = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8977).then(__webpack_require__.bind(__webpack_require__, 8977));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8977)
            ];
        }
    }
});
var GeneralCards = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(7171)]).then(__webpack_require__.bind(__webpack_require__, 67171));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67171)
            ];
        }
    }
});
var LaVidaEnBeCasa = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(3159)]).then(__webpack_require__.bind(__webpack_require__, 3159));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3159)
            ];
        }
    }
});
var AboutUs = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(3891)]).then(__webpack_require__.bind(__webpack_require__, 63891));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63891)
            ];
        }
    }
});
var AnchorMenu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7173).then(__webpack_require__.bind(__webpack_require__, 87173));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87173)
            ];
        }
    }
});
var Apartments = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(5044), __webpack_require__.e(1699)]).then(__webpack_require__.bind(__webpack_require__, 52900));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52900)
            ];
        }
    }
});
var Blog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3890).then(__webpack_require__.bind(__webpack_require__, 13890));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13890)
            ];
        }
    }
});
var CardsBlog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4547).then(__webpack_require__.bind(__webpack_require__, 64547));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64547)
            ];
        }
    }
});
var ContactForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(5518), __webpack_require__.e(2667), __webpack_require__.e(8400), __webpack_require__.e(949)]).then(__webpack_require__.bind(__webpack_require__, 53989));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53989)
            ];
        }
    }
});
var CrossTemplate = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(2667), __webpack_require__.e(2548)]).then(__webpack_require__.bind(__webpack_require__, 2548));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2548)
            ];
        }
    }
});
var ExploreZone = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7283).then(__webpack_require__.bind(__webpack_require__, 17283));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17283)
            ];
        }
    }
});
var Facilities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(3400)]).then(__webpack_require__.bind(__webpack_require__, 33400));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33400)
            ];
        }
    }
});
var FlexibleLegal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8269).then(__webpack_require__.bind(__webpack_require__, 28269));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28269)
            ];
        }
    }
});
var FlexibleText = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9720).then(__webpack_require__.bind(__webpack_require__, 59720));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59720)
            ];
        }
    }
});
var Gallery = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8801).then(__webpack_require__.bind(__webpack_require__, 68801));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68801)
            ];
        }
    }
});
var GenericActivities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(8497)]).then(__webpack_require__.bind(__webpack_require__, 8497));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8497)
            ];
        }
    }
});
var Histories = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(4609)]).then(__webpack_require__.bind(__webpack_require__, 94609));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94609)
            ];
        }
    }
});
var Housing = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(334)]).then(__webpack_require__.bind(__webpack_require__, 40334));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40334)
            ];
        }
    }
});
var MapTemplate = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9936).then(__webpack_require__.bind(__webpack_require__, 89936));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89936)
            ];
        }
    }
});
var NewOpening = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5009).then(__webpack_require__.bind(__webpack_require__, 95009));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95009)
            ];
        }
    }
});
var Newsletter = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1643).then(__webpack_require__.bind(__webpack_require__, 21643));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21643)
            ];
        }
    }
});
var Press = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(9796)]).then(__webpack_require__.bind(__webpack_require__, 49796));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49796)
            ];
        }
    }
});
var PriceDetail = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1591).then(__webpack_require__.bind(__webpack_require__, 41591));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41591)
            ];
        }
    }
});
var PriceSave = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5255).then(__webpack_require__.bind(__webpack_require__, 35255));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35255)
            ];
        }
    }
});
var Recomended = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(5896)]).then(__webpack_require__.bind(__webpack_require__, 85896));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85896)
            ];
        }
    }
});
var SharedSpaces = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(5352)]).then(__webpack_require__.bind(__webpack_require__, 65352));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65352)
            ];
        }
    }
});
var SpecficActivities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(2316)]).then(__webpack_require__.bind(__webpack_require__, 2316));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2316)
            ];
        }
    }
});
var Sustainability = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6502).then(__webpack_require__.bind(__webpack_require__, 36502));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36502)
            ];
        }
    }
});
var WhatToDo = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(5518), __webpack_require__.e(3263)]).then(__webpack_require__.bind(__webpack_require__, 63263));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63263)
            ];
        }
    }
});
var WhatsIncluded = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8544).then(__webpack_require__.bind(__webpack_require__, 88544));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88544)
            ];
        }
    }
});
var WhereWeAre = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7400).then(__webpack_require__.bind(__webpack_require__, 37400));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37400)
            ];
        }
    }
});
var FLEXIBLE_CONTENT_MAPS = {
    Contenidoflexible_Contenido_Hero: Hero,
    Contenidoflexible_Contenido_NoTePierdasNada: Newsletter,
    Contenidoflexible_Contenido_Faqs: Faqs,
    Contenidoflexible_Contenido_LaVidaEnBeCasa: LaVidaEnBeCasa,
    Contenidoflexible_Contenido_Mapa: MapTemplate,
    Contenidoflexible_Contenido_ModuloTarjetas_beneficio: Benefits,
    Contenidoflexible_Contenido_ModuloTarjetas_blog: CardsBlog,
    Contenidoflexible_Contenido_ModuloTarjetas_historia: Histories,
    Contenidoflexible_Contenido_ModuloTarjetas_otros: GeneralCards,
    Contenidoflexible_Contenido_ModuloTarjetas_recomendaciones: Recomended,
    Contenidoflexible_Contenido_ModuloTarjetas_sobreNosotros: AboutUs,
    Contenidoflexible_Contenido_ModuloTarjetas_actividadesGenericas: GenericActivities,
    Contenidoflexible_Contenido_ModuloTarjetas_actividadesEspecificas: SpecficActivities,
    Contenidoflexible_Contenido_ModuloTarjetas_instalaciones: Facilities,
    Contenidoflexible_Contenido_Apartamentos: Apartments,
    Contenidoflexible_Contenido_Alojamientos: Housing,
    Contenidoflexible_Contenido_Cross: CrossTemplate,
    Contenidoflexible_Contenido_QueIncluye: WhatsIncluded,
    Contenidoflexible_Contenido_QueHacer: WhatToDo,
    Contenidoflexible_Contenido_ExploreZone: ExploreZone,
    Contenidoflexible_Contenido_Press: Press,
    Contenidoflexible_Contenido_NewOpening: NewOpening,
    Contenidoflexible_Contenido_Gallery: Gallery,
    Contenidoflexible_Contenido_Sustainability: Sustainability,
    Contenidoflexible_Contenido_EstamosAqui: WhereWeAre,
    Contenidoflexible_Contenido_MasInformacion: ContactForm,
    Contenidoflexible_Contenido_FiltroPosts: Blog,
    Contenidoflexible_Contenido_LegalFlexible: FlexibleLegal,
    Contenidoflexible_Contenido_TextoFlexible: FlexibleText,
    Contenidoflexible_Contenido_Precios_Detail: PriceDetail,
    Contenidoflexible_Contenido_Precios_Save: PriceSave,
    Contenidoflexible_Contenido_AnchorMenu: AnchorMenu,
    Contenidoflexible_Contenido_PopupCorner: PopUpCorner,
    Contenidoflexible_Contenido_EspaciosComunes: SharedSpaces,
    Contenidoflexible_Contenido_BuildingCarrousel: BuildingCarrousel,
    Contenidoflexible_Contenido_Popupopenpage: PopUpOpenPage
};
/**
 * FlexibleContent
 */ // TODO: Fix types
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var FlexibleContent = function(param) {
    var flexibleContent = param.flexibleContent;
    var t = (0,useTranslation/* default */.Z)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            flexibleContent.map(function(flexible, index) {
                if (FLEXIBLE_CONTENT_MAPS.hasOwnProperty(flexible === null || flexible === void 0 ? void 0 : flexible.__typename)) {
                    var Component = FLEXIBLE_CONTENT_MAPS[flexible.__typename];
                    // TODO: Fix types
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    return /*#__PURE__*/ (0,react.createElement)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, flexible), {
                        index: index,
                        key: index
                    }));
                }
                // TODO: Remove this when all sections are included
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: 'Section with name "'.concat(flexible === null || flexible === void 0 ? void 0 : flexible.__typename, '" not included in [...uri.js]')
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappPopup, {
                label: t("whatsappPopup.label"),
                url: t("whatsappPopup.url"),
                icon: "https://cmseditor.becasaessential.com/wp-content/uploads/2026/04/whatsapp_logo.png"
            })
        ]
    });
};
FlexibleContent.displayName = "FlexibleContent";

;// CONCATENATED MODULE: ./components/templates/flexible-content/index.ts

/* harmony default export */ var flexible_content = (FlexibleContent);


/***/ }),

/***/ 7776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PostPage": function() { return /* binding */ PostPage; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _uri_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./components/templates/flexible-content/index.ts + 1 modules
var flexible_content = __webpack_require__(53835);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(80261);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./public/assets/icons/Autor.svg
var Autor = __webpack_require__(7664);
// EXTERNAL MODULE: ./public/assets/icons/Calendar.svg
var Calendar = __webpack_require__(71937);
// EXTERNAL MODULE: ./public/assets/icons/Tiempo.svg
var Tiempo = __webpack_require__(68931);
;// CONCATENATED MODULE: ./components/atoms/characteristics-posts/CharacteristicsPosts.tsx





/**
 * CharacteristicsPosts
 */ var CharacteristicsPosts = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, author = param.author, averageTimeToRead = param.averageTimeToRead, postDate = param.postDate;
    var ref = (0,useTranslation/* default */.Z)("common"), t = ref.t, lang = ref.lang;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "inline-flex flex-row flex-wrap gap-2 italic ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center gap-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar["default"], {
                        width: 20,
                        height: 20
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: new Intl.DateTimeFormat(lang).format(postDate)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block border-l border-primary-200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center gap-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Autor["default"], {
                        width: 20,
                        height: 20
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: author
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block border-l border-primary-200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center gap-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tiempo["default"], {
                        width: 20,
                        height: 20
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            averageTimeToRead,
                            " ",
                            t("components.atoms.characteristicsPost.averageReading")
                        ]
                    })
                ]
            })
        ]
    });
};
CharacteristicsPosts.displayName = "CharacteristicsPosts";

;// CONCATENATED MODULE: ./components/atoms/characteristics-posts/index.ts

/* harmony default export */ var characteristics_posts = (CharacteristicsPosts);

// EXTERNAL MODULE: ./components/atoms/prose/index.ts + 1 modules
var prose = __webpack_require__(60864);
// EXTERNAL MODULE: ./components/atoms/social-media/index.ts + 1 modules
var social_media = __webpack_require__(24454);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(77215);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(62123);
;// CONCATENATED MODULE: ./components/atoms/tag/Tag.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        text-body text-body--primary rounded-full border border-primary-600 px-4 py-1 font-normal transition-colors first-letter:capitalize hover:bg-primary-600 hover:text-white focus:outline-0\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Tags
 */ var TagBase = function(_param, // eslint-disable-next-line @typescript-eslint/no-explicit-any
ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, as = _param.as, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "as",
        "children"
    ]);
    var HTMLTag = as || "a";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,es/* oneLine */.f9)(_templateObject(), className !== null && className !== void 0 ? className : ""),
        ref: ref
    }, props), {
        children: children
    }));
};
var Tag = /*#__PURE__*/ (0,react.forwardRef)(TagBase);

;// CONCATENATED MODULE: ./components/atoms/tag/index.ts

/* harmony default export */ var tag = (Tag);

// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/organisms/hero/index.ts + 1 modules
var organisms_hero = __webpack_require__(8977);
;// CONCATENATED MODULE: ./components/templates/post/Post.tsx







/**
 * Post
 */ var Post = function(param) {
    var averageTimeToRead = param.averageTimeToRead, content = param.content, hero = param.hero, postDate = param.postDate, author = param.author, socialMedia = param.socialMedia, labels = param.labels;
    var t = (0,useTranslation/* default */.Z)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-surface-01",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_hero["default"], {
                caption: hero.caption,
                title: hero.title,
                textColor: "alternative",
                type: "essential",
                backgroundImage: hero.bgImage,
                className: "min-h-[400px] !justify-center md:mt-16",
                textAling: "center",
                hasImage: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "u-wrapper-narrow -translate-y-1/2 px-5 md:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "u-aspect-square relative h-16 md:h-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/img/img/ornamentacion.svg",
                        layout: "fill",
                        objectFit: "contain",
                        alt: "logo Be Casa Essentinal"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "u-wrapper-narrow flex flex-col px-5 font-thin md:px-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(characteristics_posts, {
                        author: author,
                        averageTimeToRead: averageTimeToRead,
                        postDate: (0,_instanceof/* default */.Z)(postDate, Date) ? postDate : new Date(postDate),
                        className: "border-b border-primary-200 pb-6 md:pb-10"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(prose/* default */.Z, {
                        html: content,
                        as: "article",
                        className: "mt-6 !text-primary-400 md:mt-10 [&>p>a]:font-bold [&>p>a]:text-text-primary [&>p>strong]:text-text-primary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-10 flex flex-col justify-between gap-4 border-y py-6",
                        children: [
                            socialMedia && /*#__PURE__*/ (0,jsx_runtime.jsx)(social_media/* default */.Z, {
                                variants: "primary",
                                icons: socialMedia,
                                text: t("components.templates.post.Share"),
                                iconSize: 27
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-2 overflow-auto",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("components.templates.post.labels")
                                    }),
                                    labels && labels.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-row gap-3",
                                        children: labels.map(function(child, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                prefetch: false,
                                                passHref: true,
                                                href: child.href,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tag, {
                                                    children: child.text
                                                })
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                        className: "mx-auto my-10",
                        onClick: function() {
                            return window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "smooth"
                            });
                        },
                        underline: true,
                        variant: "primary",
                        as: "button",
                        children: t("components.templates.post.scrollTop")
                    })
                ]
            })
        ]
    });
};
Post.displayName = "Post";

;// CONCATENATED MODULE: ./components/templates/post/index.ts

/* harmony default export */ var templates_post = (Post);

// EXTERNAL MODULE: ./components/Layout.tsx + 12 modules
var Layout = __webpack_require__(25538);
;// CONCATENATED MODULE: ./pages/blog/[uri].tsx





var __N_SSG = true;
var PostPage = function(param) {
    var flexibleContent = param.flexibleContent, post = param.post;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(templates_post, (0,_object_spread/* default */.Z)({}, post)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(flexible_content/* default */.Z, {
                flexibleContent: flexibleContent
            })
        ]
    });
};
PostPage.getLayout = Layout/* getLayout */.G;
/* harmony default export */ var _uri_ = (PostPage);


/***/ }),

/***/ 80261:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7061,5538,8977,9774,2888,179], function() { return __webpack_exec__(97516); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);